import Link from 'molecules/Link';

import { hasArrayValues } from 'utils/array/arrays';

import type { FC } from 'react';

interface FooterMenusProps {
  menus: FooterMenus[];
}

const Menus: FC<FooterMenusProps> = ({ menus }) => (
  <div
    className="
      grid w-full grid-cols-2 gap-x-8 gap-y-6  
      sm:grid-cols-2 md:grid-cols-2 
      lg:flex lg:flex-wrap lg:gap-10"
  >
    {menus?.map(menu => {
      if (!menu || !menu.heading) {
        return;
      }

      return (
        <div key={menu.heading} className="w-full md:w-[calc(50%-32px)] lg:w-[calc(25%-40px)]">
          <h3 className="mb-4 font-roboto text-md font-semibold text-white">{menu.heading}</h3>
          <ul className="flex flex-col gap-3">
            {hasArrayValues(menu.links) &&
              menu.links?.map(subMenu => {
                if (!subMenu.label) {
                  return;
                }

                return (
                  <li key={subMenu.label}>
                    <Link
                      href={subMenu.link}
                      className="font-roboto text-sm text-gray-300 hover:text-primary-100"
                      enablePreview={false}
                    >
                      {subMenu?.label}
                    </Link>
                  </li>
                );
              })}
          </ul>
        </div>
      );
    })}
  </div>
);
export default Menus;
